import { makeStyles } from "@material-ui/core/styles";

export const cardStyles = makeStyles({
    root: {
        // background: "#fff",
        // borderRadius: 5,
        border: 0,
        // color: "white",
        height: "100%",
        padding: "10px"
        // boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)"
    },
    questionContainer: {
        justifyContent: "space-between",
        padding: 10,
        border: 0,
        borderRadius: 3,
        background: "#FFFFFF",
        // boxShadow: "0 3px 5px 2px rgba(181, 181, 181, .71)",
        // height: "100%"
        overflowY: "scroll"
    },

    //DECK CONTAINER SECTION
    deckContainer: {
        justifyContent: "space-between",
        padding: 10,
        border: 0,
        borderRadius: 15,
        // boxShadow: "0 3px 5px 2px rgba(181, 181, 181, .71)",
        height: "100%"
    },
    //DECK CONTAINER SECTION ABOVE ^^
    homeDeckButtonContainer: {
        display: "flex",
        background: "linear-gradient(45deg, transparent, transparent)"
    },
    homeDeckContainer: {
        justifyContent: "space-between",
        padding: "1.5em",
        borderRadius: 15,
        background: "#e8e8e8",
        // boxShadow: "0 3px 5px 2px rgba(181, 181, 181, .71)",
        height: "11em !important",
        width: "8em !important",
        marginLeft: "10px !important",
        marginRight: "0px !important",
        marginTop: "5px !important",
        marginBottom: "10px !important"
    },

    gridContainer: {
        paddingBottom: 10,
        paddingTop: 10,
        paddingLeft: 5,
        paddingRight: 5
    },
    deckButtonContainer: {
        display: "flex",
        flexDirection: "flex-end",
        marginTop: 10
    },
    //Test Cards
    testCardContainer: {
        display: "flex",
        flexDirection: "row",
        // padding: "0px !important",
        border: 0,
        borderRadius: "0px !important",
        maxWidth: "100% !important",
        // boxShadow: "0 3px 5px 2px rgba(181, 181, 181, .71)",
        height: "100%"
        // marginTop: "1.5em",
        // marginBottom: ".5em"
    },
    testCardTextContainer: {
        display: "flex",
        justifyContent: "center"
    },
    testCardRowContainer: {
        padding: 5
    },
    testCardTextGrid: {
        width: "100%"
    },
    testCardDivder: {
        flexBasis: "0% !important",
        marginTop: ".3em",
        height: "85%"
    },
    questionTextContainer: {
        border: 0,
        paddingTop: "0px !important",
        height: "100%",
        padding: "10px"
    }
});
